<template>
    <div class="mc-root mc-customer-return">
        <div class="mc-page">
            <mc-page-header title="Ricevimento resi cliente" />
            <customer-return-create @created="refreshRecentReturns" />
            <customer-return-generation />
            <customer-return-recent ref="recentReturns" />
        </div>
    </div>
</template>

<script>
import CustomerReturnCreate from "./include/CustomerReturnCreate";
import CustomerReturnRecent from "./include/CustomerReturnRecent";
import McPageHeader from "@/assets/mecom/vue/McPageHeader.vue";
import CustomerReturnGeneration from "./include/CustomerReturnGeneration.vue";

export default {
    name: "CustomerReturnPage",
    components: { CustomerReturnCreate, CustomerReturnRecent, CustomerReturnGeneration, McPageHeader },
    methods: {
        refreshRecentReturns() {
            this.$refs.recentReturns.load();
        },
    },
};
</script>

<style src="./include/customerReturnMecom.css"></style>
